import { render, staticRenderFns } from "./MedicalRecordEntry.vue?vue&type=template&id=13b0d1f4&"
import script from "./MedicalRecordEntry.vue?vue&type=script&lang=js&"
export * from "./MedicalRecordEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports